import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5438_9845)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.5 12C24.5 18.6274 19.1274 24 12.5 24C5.87258 24 0.5 18.6274 0.5 12C0.5 5.37258 5.87258 0 12.5 0C19.1274 0 24.5 5.37258 24.5 12ZM6.83249 13.5711L6.89702 14.7466C6.90124 14.8267 6.93125 14.902 6.98189 14.9637C7.04577 15.0411 7.14982 15.1532 7.29848 15.2849L7.32251 15.3061C8.01093 15.9066 9.60249 16.8875 12.499 16.8875C15.4093 16.8875 16.9895 15.91 17.6749 15.309L17.6748 15.309L17.7034 15.2837L17.7034 15.2837C17.8452 15.157 17.946 15.0486 18.0101 14.9717C18.0654 14.9053 18.0973 14.8229 18.1024 14.7363L18.1664 13.5719C18.5922 13.3383 19.0317 13.0743 19.0317 13.0743C19.7227 12.7 20.494 13.2378 20.4954 14.0266C20.4977 15.3028 19.5005 16.6143 18.1554 17.4408C16.6388 18.3728 14.3748 18.7594 12.5 18.7594C10.6252 18.7594 8.36121 18.3728 6.84456 17.4408C5.49949 16.6143 4.5023 15.3033 4.50464 14.0266C4.50605 13.2378 5.27727 12.7 5.96832 13.0743C5.96832 13.0743 6.40708 13.3377 6.83249 13.5711ZM17.4053 5.43398C16.2163 5.29741 15.4235 5.22913 12.4995 5.22913C9.99078 5.22913 8.76807 5.32001 7.59366 5.43398C7.04467 5.48719 6.60679 5.90491 6.64711 6.45731L7.08505 12.4231C7.22222 12.4628 7.37181 12.513 7.53958 12.5693C8.41804 12.8641 9.79511 13.3263 12.4994 13.3263C15.2038 13.3263 16.5809 12.8641 17.4593 12.5693C17.6269 12.5131 17.7764 12.4629 17.9134 12.4232L18.3513 6.45731C18.3921 5.90491 17.9528 5.49708 17.4048 5.43398H17.4053Z"
        fill="#ECEDEE"
      />
    </g>
    <defs>
      <clipPath id="clip0_5438_9845">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)
